export default function Loading({classColor='text-dark'}){
    return (
        <div className={`spinner-border ${classColor}`} role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}